import templateUrl from 'emun.promotion/promo-webcontent-prompt.htm'
import controller from 'emun.promotion/promo-webcontent-prompt.controller'
import modals from 'webmodals/modals'

export default (options) => modals.open(Object.assign({
    size: options.size || 'md',
    backdrop: 'static',
    templateUrl: templateUrl,
    controller,
    bindToController: true,
    controllerAs: '$ctrl',
    resolve: {
        options: () => Object.assign({}, options),
        modals: modals
    }
}, options.modal)).result;